import FormHelperText from '@material-ui/core/FormHelperText';
import { withStyles } from '@material-ui/core/styles';

import { colors, fonts } from '../styles';

// https://material-ui.com/api/form-helper-text/

export const Caption = withStyles({
  root: {
    fontSize: fonts.size.smallest,
    color: colors.gray.dark,
    fontWeight: fonts.weight.regular,
    lineHeight: '17px',
    letterSpacing: '0',
  },
  error: {
    '&&': {
      color: colors.error.default,
    },
  },
  focused: {
    color: colors.black,
  },
})(FormHelperText);
